// import React from 'react'
// import { useParams } from 'react-router-dom';
// import doctors from '../doctors'

// const Overview = () => {
//   const { id } = useParams();
//   const doctor = doctors.find(doc => doc.id === parseInt(id));

//   return (
//     <>
//       <h2 style={{color: 'blue'}}>{doctor.name}</h2>
//       <label>{doctor.degree}</label>
//       <p style={{margin: '1rem 0'}}>{doctor.description}</p>
//       <h3 style={{color: 'blue'}}>Specialities</h3>
//       <ul>
//         {doctor.specialities.map((speciality, index) => (
//           <li key={index}>{speciality}</li>
//         ))}
//       </ul>
//     </>
//   )
// }

// export default Overview

import StyleDocDetail from "../docdetail.module.css";
import { Typography, List } from "@mui/material";
import { motion } from "framer-motion";

const Overview = ({ doctor }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <Typography variant="body1" paragraph style={{ color: "gray" }}>
        {doctor.description}
      </Typography>

      <Typography variant="h5" gutterBottom>
        Specialities
      </Typography>

      <List>
        {doctor.specialities.map((speciality, index) => (
          <motion.div
            key={index}
            whileHover={{ scale: 1.03 }}
            transition={{ type: "spring", stiffness: 300 }}
          >
            <div className={StyleDocDetail.badges}>
              <span key={index} className={StyleDocDetail.badge}>
                {speciality}
              </span>
            </div>
          </motion.div>
        ))}
      </List>
    </motion.div>
  );
};

export default Overview;
